import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export function ProtectedRoute(){
  const { token, loading } = useAuth();
  if (loading) return <div className="flex items-center justify-center min-h-[40vh] text-slate-400 text-sm">Carregando...</div>;
  if (!token) return <Navigate to="/login" replace />;
  return <Outlet />;
}
